/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Check_In_GuestInputs */

const en_verify_check_in_guest = /** @type {(inputs: Verify_Check_In_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check In Guest`)
};

const es_verify_check_in_guest = /** @type {(inputs: Verify_Check_In_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar Invitado`)
};

const fr_verify_check_in_guest = /** @type {(inputs: Verify_Check_In_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer l'invité`)
};

const de_verify_check_in_guest = /** @type {(inputs: Verify_Check_In_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gast einchecken`)
};

const id_verify_check_in_guest = /** @type {(inputs: Verify_Check_In_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-In Tamu`)
};

/** @type {(inputs: Verify_Check_In_GuestInputs) => LocalizedString} */
const ja_verify_check_in_guest = en_verify_check_in_guest;

/** @type {(inputs: Verify_Check_In_GuestInputs) => LocalizedString} */
const zh_verify_check_in_guest = en_verify_check_in_guest;

/** @type {(inputs: Verify_Check_In_GuestInputs) => LocalizedString} */
const ar_verify_check_in_guest = en_verify_check_in_guest;

/** @type {(inputs: Verify_Check_In_GuestInputs) => LocalizedString} */
const it_verify_check_in_guest = en_verify_check_in_guest;

/** @type {(inputs: Verify_Check_In_GuestInputs) => LocalizedString} */
const ru_verify_check_in_guest = en_verify_check_in_guest;

/** @type {(inputs: Verify_Check_In_GuestInputs) => LocalizedString} */
const pt_verify_check_in_guest = en_verify_check_in_guest;

/** @type {(inputs: Verify_Check_In_GuestInputs) => LocalizedString} */
const ko_verify_check_in_guest = en_verify_check_in_guest;

/**
* | output |
* | --- |
* | "Check In Guest" |
*
* @param {Verify_Check_In_GuestInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_check_in_guest = /** @type {((inputs?: Verify_Check_In_GuestInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Check_In_GuestInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_check_in_guest(inputs)
	if (locale === "es") return es_verify_check_in_guest(inputs)
	if (locale === "fr") return fr_verify_check_in_guest(inputs)
	if (locale === "de") return de_verify_check_in_guest(inputs)
	if (locale === "ja") return ja_verify_check_in_guest(inputs)
	if (locale === "zh") return zh_verify_check_in_guest(inputs)
	if (locale === "ar") return ar_verify_check_in_guest(inputs)
	if (locale === "id") return id_verify_check_in_guest(inputs)
	if (locale === "it") return it_verify_check_in_guest(inputs)
	if (locale === "ru") return ru_verify_check_in_guest(inputs)
	if (locale === "pt") return pt_verify_check_in_guest(inputs)
	return ko_verify_check_in_guest(inputs)
});